module.exports = __webpack_public_path__ + "static/biennale-semi-bold-it-a5db8f2f7bee67c0dc521fe29f2b522c.otf";